/**
 * Theme mode hook — thin wrapper around MUI's useColorScheme.
 *
 * MUI handles persistence (localStorage), FOUC prevention (InitColorSchemeScript),
 * and CSS variable switching automatically via cssVariables + colorSchemes.
 */

import { useColorScheme } from '@mui/material/styles';

export function useThemeMode() {
  const { mode, setMode, systemMode } = useColorScheme();

  // Resolve the effective mode (when mode is 'system', use systemMode)
  const resolvedMode = mode === 'system' ? (systemMode ?? 'light') : (mode ?? 'light');

  const toggleMode = () => {
    setMode(resolvedMode === 'dark' ? 'light' : 'dark');
  };

  return { mode: resolvedMode, toggleMode };
}
